/**
 * eu-warranty-label.js
 * Still Smirking — progressive-enhancement layer for the EU harmonised
 * legal guarantee notice (footer / product / cart-drawer).
 *
 * Baseline (no JS): the trigger is a real <a href> to the raw notice SVG,
 * opened in a new tab — always reachable, always the full unaltered file.
 *
 * Enhanced (JS + <dialog> support): intercepts the click and opens an
 * in-page <dialog> instead, so the visitor never leaves the page. Falls
 * back to the plain link automatically wherever <dialog>.showModal is
 * unavailable.
 */
(function () {
  function openDialog(trigger, event) {
    var targetId = trigger.getAttribute('data-eu-warranty-target');
    var dialog = targetId && document.getElementById(targetId);

    if (!dialog || typeof dialog.showModal !== 'function') {
      return; // no <dialog> support — let the default link navigation happen
    }

    event.preventDefault();
    dialog.showModal();
  }

  function bindCloseControls(dialog) {
    var closeBtn = dialog.querySelector('[data-eu-warranty-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        dialog.close();
      });
    }

    // Click on the ::backdrop counts as a click on the dialog element
    // itself (outside dialog__dialog-inner) — close on that too.
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        dialog.close();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var triggers = document.querySelectorAll('[data-eu-warranty-trigger]');
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        openDialog(trigger, event);
      });
    });

    var dialogs = document.querySelectorAll('.ss-eu-warranty__dialog');
    dialogs.forEach(bindCloseControls);
  });
})();
